import { apiClient } from './client';
import type { DeviceSecurityResponse } from '@/types/oscar';

/** Every Intune-enrolled Windows device with its Defender level and whether CrowdStrike is still on it. */
export function getDeviceSecurity(signal?: AbortSignal): Promise<DeviceSecurityResponse> {
  return apiClient.get<DeviceSecurityResponse>('/api/device-security', signal);
}
